import EmptyBoxIcon from '@assets/images/empty-box.svg?react'
import { useCustomTheme } from '@/core/theme'
import './table-emtpy.scss'

const TableEmpty = ({ message }: { message: string }) => {
    const theme = useCustomTheme()

    // @ts-ignore
    const svgColor = theme.colors.semantic.background

    return (
        <section className="asm-table is-empty">
            <p>{message}</p>
            <EmptyBoxIcon color={svgColor} />
        </section>
    )
}

export default TableEmpty
